import { reactive } from 'vue';

interface Toast {
  id: number;
  type: 'success' | 'error' | 'warning';
  title: string;
  description: string;
  duration: number;  // Duration in milliseconds
}

const state = reactive({
  toasts: [] as Toast[],
  nextId: 0,
})

const addToast = (toast: Omit<Toast, 'id'>) => {
  const newToast = { ...toast, id: state.nextId++ };
  state.toasts.push(newToast);
  setTimeout(() => removeToast(newToast.id), toast.duration || 8000);
};

const removeToast = (id: number) => {
  const index = state.toasts.findIndex(t => t.id === id);
  if (index !== -1) {
    state.toasts.splice(index, 1);
  }
};

export const useToast = () => {
  return { state, addToast, removeToast };
};
